export default "__VITE_ASSET__90dd8137__"